import { CourseLessonSectionGroupTable } from "components/course/CourseLessonSectionGroupTable";
import {
  BoxDanger,
  MnemoCallout,
  MnemoLoading,
  SupportoTecnico,
  Title,
} from "components/misc";
import { ROUTES } from "const";
import { Icon } from "design-react-kit";
import {
  learningService,
  lessonSectionService,
  networkErrorHelper,
} from "libs";
import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";

class CourseLessonSectionGroupSchedule extends Component {
  state = {
    loading: true,
    loadingError: false,
    rCode: "",
    course: {},
    userCourse: {},
    lessons: [],
    sections: [],
    sectionsGroup: [],
    analytics: [],
    lessonCreditRecognition: [],
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });
    this.loadUserCourse(rCode);
  }

  loadUserCourse(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });

        this.loadRemote(course.id, userCourse.registrationCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(courseId, rCode) {
    lessonSectionService
      .MySchedule(courseId, rCode)
      .then(({ data }) => {
        this.setState({
          loading: false,
          lessons: data.payload.lessons,
          sections: data.payload.sections,
          sectionsGroup: data.payload.sectionsGroup || [],
          analytics: data.payload.analytics,
          lessonCreditRecognition: data.payload.lessonCreditRecognition || [],
        });
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        }

        this.setState({
          loading: false,
          ladingError: true,
        });
      });
  }

  render() {
    const { loading, loadingError, rCode } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;
    if (loadingError)
      return (
        <BoxDanger className="m-5">
          Si è verificato un errore durante l'elaborazione della richiesta, se
          il problema persiste <SupportoTecnico />
        </BoxDanger>
      );

    // show tirocinio diretto ony for courseType 'ABILITAZIONI60CFU'
    const {      
      userCourse,
      lessons,
      sections,
      sectionsGroup,
      analytics,
      lessonCreditRecognition,
    } = this.state;

   
    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Attività formative</Title>
        <CourseLessonSectionGroupTable
          rCode={rCode}
          userCourse={userCourse}
          lessons={lessons}
          sections={sections}
          sectionsGroup={sectionsGroup}
          analytics={analytics}
          lessonCreditRecognition={lessonCreditRecognition}
        />        
        <div className="m-2">
          <MnemoCallout>
            <p>
              ATTENZIONE: Calendario Attività formative in continuo
              aggiornamento.
            </p>
          </MnemoCallout>
        </div>
      </>
    );
  }
}

export default withRouter(CourseLessonSectionGroupSchedule);
